import { render, staticRenderFns } from "./menu-add.vue?vue&type=template&id=0737fc54&scoped=true&"
import script from "./menu-add.vue?vue&type=script&lang=js&"
export * from "./menu-add.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=0737fc54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0737fc54",
  null
  
)

component.options.__file = "menu-add.vue"
export default component.exports